var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandPointed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.501,
    height: 12,
    viewBox: "0 0 10.501 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hand-pointer-solid",
    d: "M2.971.938a.937.937,0,1,1,1.875,0V4.411a1.126,1.126,0,0,1,1.8.445,1.125,1.125,0,0,1,1.943.682,1.125,1.125,0,0,1,1.877.837V9a3,3,0,0,1-3,3h-2a2.385,2.385,0,0,1-.345-.023,4.7,4.7,0,0,1-3.281-1.852L.159,7.875a.938.938,0,0,1,1.5-1.125L2.971,8.5ZM5.6,7.125a.375.375,0,0,0-.75,0v2.25a.375.375,0,0,0,.75,0ZM6.721,6.75a.376.376,0,0,0-.375.375v2.25a.375.375,0,0,0,.75,0V7.125A.376.376,0,0,0,6.721,6.75ZM8.6,7.125a.375.375,0,1,0-.75,0v2.25a.375.375,0,0,0,.75,0Z",
    transform: "translate(0.03)",
    fill: "#006B8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPointed);
export default __webpack_public_path__ + "static/media/hand-pointed.a689027ea66bdc68180b5e6d680147c2.svg";
export { ForwardRef as ReactComponent };